import { defineComponent } from 'vue';
import type { RouteRecordRaw } from 'vue-router';
import { getStringQueryValue } from '@/utils/query.ts';

// Renders nothing. Used for routes that are handled entirely by navigation guards
// (e.g. /auth/callback triggers parseHash + redirect, /auth/logout triggers Auth0 logout).
// Vue Router requires a component for every route, so this satisfies that constraint.
const AuthPlaceholderRouteView = defineComponent({
    name: 'AuthPlaceholderRouteView',
    render: () => null,
});

const authRoutes: RouteRecordRaw[] = [
    {
        path: '/auth/error',
        name: 'auth.error',
        component: () => import('@/views/AuthError.vue'),
        props: (route) => ({
            error: getStringQueryValue(route.query.error),
            target: getStringQueryValue(route.query.target),
        }),
        meta: {
            splashscreen: true,
        },
    },
    {
        path: '/auth/callback',
        name: 'auth.callback',
        component: AuthPlaceholderRouteView,
        meta: {
            auth: false,
        },
    },
    {
        path: '/auth/mfa-callback',
        name: 'auth.mfaCallback',
        component: AuthPlaceholderRouteView,
        meta: {
            auth: false,
        },
    },
    {
        path: '/auth/logout',
        name: 'auth.logout',
        component: AuthPlaceholderRouteView,
        meta: {
            auth: false,
        },
    },
    {
        path: '/new-password',
        name: 'auth.newPassword',
        component: () => import('@/views/Auth/NewPassword.vue'),
        props: (route) => ({ token: route.query.t, email: route.query.e }),
        meta: {
            auth: false,
        },
    },
];

export default authRoutes;
